import type { AceCtaTypeType } from "../../../../common-deprecated/ace/types";
import type { AceCtaTrackingType } from "../../../../common-deprecated/tracking/types";
import type { AceCtaButtonType } from "../../ace/types";

const getDefaultTracking = (title: string = "", type?: AceCtaTypeType): AceCtaTrackingType | string => {
    switch (type) {
        case "dealerfinder":
            return "dealerfinder";
        case "download":
            return "online-brochure";
        case "ebrochurepersonalized":
            return "personalized-ebrochure";
        case "save":
            return "save-config";
        case "sendtodealer":
            return "send-to-dealer";
        case "testdrive":
            return "test-drive";
        case "custom":
        default:
            return title;
    }
};
// Parse a AEM cta configuration into the cta config object used in frontend.
// These are the objects used to render the CTA links/buttons.

export const parseAceCtaItem = (config: Partial<AceCtaButtonType>): AceCtaButtonType => ({
    title: config.title || "",
    isPrimary: config.isPrimary || false,
    type: config.type,
    url: config.url,
    target: config.target,
    jsfunction: config.jsfunction,
    tracking: config.tracking || getDefaultTracking(config.title, config.type),
});
